import { v4 as uuidv4 } from 'uuid';
import { ImportLoraData } from '@/types/node';
import { FlowGraph } from '../FlowGraph';
import type { Lora, NodeId } from 'web';

export const minWeight = 0.0;
export const maxWeight = 4.0;

export class LoraView {
  constructor(
    private graph: FlowGraph,
    private nodeId: NodeId,
  ) {}

  setLora(loraId: string) {
    this.setLoras([
      { id: uuidv4(), file: loraId, name: 'Untitled', coverImage: undefined, defaultWeight: 0.5, trigger: '' },
    ]);
  }

  addLora() {
    const loras = this.getLoras();
    if (loras === undefined) {
      return;
    }
    this.setLoras([
      ...loras,
      { id: uuidv4(), file: '', name: 'Untitled', coverImage: undefined, defaultWeight: 0.5, trigger: '' },
    ]);
  }

  updateLora(lora: Lora) {
    const loras = this.getLoras();
    if (loras === undefined) {
      return;
    }
    this.setLoras(loras.map((l) => (l.id === lora.id ? lora : l)));
  }

  deleteLora(id: string) {
    const loras = this.getLoras();
    if (loras === undefined) {
      return;
    }
    this.setLoras(loras.filter((lora) => lora.id !== id));
  }

  private setLoras(loras: Lora[]) {
    this.graph.wasmEdit((wasm) => wasm.setLoras(this.nodeId, loras));
    this.graph.updateNodeOutputs(this.nodeId);
  }

  private getLoras() {
    return this.graph.store.getNodeDataNullable<ImportLoraData>(this.nodeId)?.loras;
  }

  setSelectedIndex(selectedIndex: number) {
    this.graph.wasmEdit((wasm) => wasm.setSelectedIndex(this.nodeId, selectedIndex));
    this.graph.updateNodeOutputs(this.nodeId);
  }

  setWeight(weight: number, ongoing: boolean) {
    weight = Math.min(Math.max(weight, minWeight), maxWeight);
    this.graph.wasmEdit((wasm) => wasm.setLoraWeight(this.nodeId, weight), ongoing);
    this.graph.updateNodeOutputs(this.nodeId);
  }
}
